<template>
  <div>
    <div class="card card-custom gutter-b">
      <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label font-weight-bolder text-dark">
            🚀 Novidades do Sistema Nuts
          </span>
          <span class="text-muted mt-3 font-weight-bold font-size-sm">
            Confira tudo o que foi lançado e melhorado
          </span>
        </h3>
      </div>

      <div class="card-body pt-0 pb-6">
        <div v-if="loading" class="text-center py-10">
          <b-spinner variant="primary" />
          <p class="mt-3 text-muted">Carregando novidades...</p>
        </div>

        <div v-else-if="erro" class="alert alert-light-danger d-flex align-items-center justify-content-between p-4">
          <span>{{ erro }}</span>
          <button class="btn btn-sm btn-light-danger font-weight-bold" @click="carregar">
            Tentar novamente
          </button>
        </div>

        <div v-else-if="pacotes.length === 0" class="text-center text-muted py-10">
          Nenhuma novidade publicada ainda.
        </div>

        <div v-else>
          <div
            v-for="pacote in pacotes"
            :key="pacote.id"
            class="card border mb-6 shadow-sm"
          >
            <div class="card-body">
              <div class="d-flex align-items-start justify-content-between flex-wrap mb-3">
                <div>
                  <h5 class="font-weight-bolder text-dark mb-1">{{ pacote.titulo }}</h5>
                  <div class="d-flex flex-wrap mb-2" style="gap: 8px;">
                    <span class="label label-inline label-light-primary font-weight-bold" v-if="pacote.versao">
                      Versão {{ pacote.versao }}
                    </span>
                    <span class="label label-inline label-light-secondary font-weight-bold" v-if="pacote.data_publicacao">
                      {{ formatDate(pacote.data_publicacao) }}
                    </span>
                    <span class="label label-inline label-light-success font-weight-bold" v-if="pacote.itens && pacote.itens.length">
                      {{ pacote.itens.length }} {{ pacote.itens.length === 1 ? "novidade" : "novidades" }}
                    </span>
                  </div>
                  <p class="text-muted font-size-sm mb-0" v-if="pacote.descricao_curta">
                    {{ pacote.descricao_curta }}
                  </p>
                </div>
                <button
                  class="btn btn-light-primary btn-sm font-weight-bolder mt-2"
                  @click="verDetalhes(pacote)"
                >
                  Ver detalhes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalNovidades
      modal-id="modal-novidades-historico"
      :pacote="pacoteSelecionado"
      @fechar="pacoteSelecionado = null"
      @lido="pacoteSelecionado = null"
    />
  </div>
</template>

<script>
import { SistemaMixin } from "@/modules/Application";
import ModalNovidades from "@/modules/Dashboard/components/ModalNovidades.vue";

export default {
  name: "app-novidades-historico",
  mixins: [SistemaMixin],
  components: {
    ModalNovidades,
  },
  data() {
    return {
      loading: false,
      erro: "",
      pacotes: [],
      pacoteSelecionado: null,
    };
  },
  mounted() {
    this.$store.dispatch("setLoading", false);
    this.carregar();
  },
  methods: {
    async carregar() {
      this.loading = true;
      this.erro = "";
      try {
        const { data } = await this.$http.post("/novidades");
        this.pacotes = data.data || data || [];
      } catch (error) {
        this.erro =
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Não foi possível carregar as novidades. Tente novamente.";
      } finally {
        this.loading = false;
      }
    },

    verDetalhes(pacote) {
      this.pacoteSelecionado = pacote;
      this.$nextTick(() => {
        this.$bvModal.show("modal-novidades-historico");
      });
    },

    formatDate(date) {
      if (!date) return "";
      return this.$moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>
